// extracted by mini-css-extract-plugin
module.exports = {"tutorialVideo":"TutorialVideos_tutorialVideo__GZ4Qy","tutorialVideoTitle":"TutorialVideos_tutorialVideoTitle__9WVvB"};